import * as React from 'react';

const context = React.createContext({
  accentColor: '#0066ff',
  primaryColor: '#ffffff',
  secondaryColor: '#cbd3da',
});

export const useTheme = () => React.useContext(context);

export const Provider = context.Provider;
